import React from 'react';
import "./Return.css";

const Return = () => {
    const handleScroll = (id) => {
      const section = document.getElementById(id);
      if (section) section.scrollIntoView({ behavior: 'smooth', block: 'start' });
    };
  
    return (
      <div className="return-container">
        <div className="return-wrapper">
          {/* Sidebar */}
          <div className="sidebar">
            <h2>Returns</h2>
            <ul>
              <li onClick={() => handleScroll('refunds')} className="active">Refunds</li>
              <li onClick={() => handleScroll('late-refunds')}>Late or Missing Refunds</li>
              <li onClick={() => handleScroll('sale-items')}>Sale Items</li>
              <li onClick={() => handleScroll('exchanges')}>Exchanges</li>
              <li onClick={() => handleScroll('gifts')}>Gifts</li>
              <li onClick={() => handleScroll('shipping')}>Shipping</li>
            </ul>
          </div>
  
          {/* Content */}
          <div className="content">
            <h1>Returns Policy</h1>
  
            <div id="refunds">
              <h3>Returns</h3>
              <p>Our Returns Policy lasts 30 days... (text trimmed for brevity)</p>
              <ul className="custom-list">
                <li>Any item not in its original condition...</li>
                <li>Any item that is returned more than 30 days...</li>
              </ul>
  
              <h3>Refunds</h3>
              <p>Once your return is received and inspected...</p>
            </div>
  
            <div id="late-refunds">
              <h3>Late or Missing Refunds</h3>
              <p>If you haven’t received a refund yet...</p>
            </div>
  
            <div id="sale-items">
              <h3>Sale Items</h3>
              <p>Only regular priced items may be refunded...</p>
            </div>
  
            <div id="exchanges">
              <h3>Exchanges</h3>
              <p>We do not accept exchanges presently.</p>
            </div>
  
            <div id="gifts">
              <h3>Gifts</h3>
              <p>We do not currently accept gift exchanges and returns.</p>
            </div>
  
            <div id="shipping">
              <h3>Shipping</h3>
              <p>To return your product, contact <a href="mailto:support@horticult.co">support@horticult.co</a>...</p>
            </div>
          </div>
        </div>
      </div>
    );
  };
export default Return;
